export const ACIC_CHECK_REASONS = {
    LICENSE: 'LICENSE',
    EMPLOYMENT: 'EMPLOYMENT',
    OTHER: 'OTHER',
};
